<template>
  <b-modal
    id="editar-modelo"
    :title="$t('vModelo.editarModelo')"
    centered
    size="lg"
    hide-footer
    ref="modalEditarModelo"
    @hidden="resetModal"
  >
    <b-form @submit.stop.prevent="updateModelo">
      <p class="text-danger" v-if="existeNombre">
        El nombre ingresado ya está en uso. Por favor, ingrese un nombre
        diferente.
      </p>
      <div class="row">
        <b-col cols="12" sm="12" md="6">
          <label for="“marca”">{{ $t("vMarca.marca") }}* :</label>
          <b-form-select
            id="marca"
            v-model="selectedMarca"
            :options="marcas"
            value-field="id"
            text-field="marca"
            required
          >
            <template #first>
              <b-form-select-option :value="null" disabled>
                {{ $t("vMarca.elejirMarca") }}
              </b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" sm="12" md="6">
          <label for="“nombre”">{{ $t("vModelo.modelo") }}* :</label>
          <b-form-input
            id="input-nombre"
            v-model="datosModelo.nombre"
            :state="estatusModelo"
            aria-describedby="input-nombre-help input-nombre-feedback"
            trim
          >
          </b-form-input> 
          <b-form-invalid-feedback id="input-nombre-feedback">
            {{ $t("vModelo.msgModelo") }}
          </b-form-invalid-feedback>
        </b-col>
      </div>
      <div class="row">
        <div
          class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 d-lg-flex"
        >
          <b-btn
            color="primary"
            class="w-100"
            style="color: white"
            @click="$bvModal.hide('editar-modelo')"
          >
            {{ this.$t("Gral.cancelar") }}
          </b-btn>
        </div>
        <div
          class="col-12 col-sm-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 sepracion-div-boton-guardar"
        >
          <b-btn
            variant="info"
            class="w-100"
            style="color: white"
            type="submit"
            :disabled="estatusModelo === null || estatusModelo === false"
          >
            {{ $t("vModelo.agregarModelo") }}
          </b-btn>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import ModelosDataService from "../../../services/ModelosDataService";
import MarcasDataService from "../../../services/MarcasDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from '../../../services/Crypto';
import { generalSweetAlert } from "../../../utils/Utils";

export default {
  props: {
    datosModelo: {
      type: Object,
      default: () => ({ id: null, nombre: "", marca: { marca: "" } }),
    },
  },
  data() {
    return {
      marcas: [],
      selectedMarca: null,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      key: sessionStorage.getItem("key"),
      estatusModelo: null,
      existeNombre: false,
      oldNombre: null,
    };
  },

  mounted() {
    this.obtenerMarcasHabilitadas();
  },

  watch: {
    "datosModelo.nombre"(data) {
      this.validarNombreModelo(data);
    },
  },

  methods: {
    validarNombreModelo(nombre) { 
      if (!nombre || nombre.trim() === "") {
        this.estatusModelo = null;
        return;
      }

      this.estatusModelo = nombre.trim().length >= 5;
    },

    showModal() {
      this.selectedMarca = this.datosModelo.marca.id;
      this.oldNombre = this.datosModelo.nombre

      this.$nextTick(() => {
        this.$refs.modalEditarModelo.show();
      });
    },

    resetModal() {
      this.selectedMarca = null;
      this.existeNombre = false;
      this.oldNombre = null
      this.estatusModelo = null;
    },

    obtenerMarcasHabilitadas() {
      MarcasDataService.getAllHabilitadas().then(async (response) => {
        this.marcas = await Crypto.desencriptar(response.data, this.key);
      });
    },

    async updateModelo() {
        try {
        const data = {
          id: this.datosModelo.id,
          modelo: this.datosModelo.nombre,
          marca: this.marcas.find((item) => item.id === this.selectedMarca),
          habilitado: this.datosModelo.habilitado,
        };

        const response = await ModelosDataService.update(data, this.key)
        if(response.status === 200){
          this.$emit("actualizarTabla", response.status);
          this.$refs.modalEditarModelo.hide();
          this.accion = "Actualizó el modelo " + data.modelo;
          this.registrarAccion();

          generalSweetAlert(this.$t('vModelo.msgActualizar'), "success");

        }
      } catch (error) {
        if (error.response.status === 406) {
          this.existeNombre = true;
          this.estatusModelo = false;
        }
        generalSweetAlert(this.$t('vModelo.msgErrorActualizarModelo'), "error");
      }
    },

    registrarAccion() {
      const data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },
  },
};
</script>

<style>
@media (max-width: 959px) {
  .sepracion-div-boton-guardar {
    margin-top: -12px;
  }
}

@media (min-width: 960px) {
  .sepracion-div-boton-guardar {
    margin-top: 0px;
  }
}
</style>
